export default {
  "nav.spreadsheet": "Hoja de cálculo",
  "nav.categories": "Categorías",
  "nav.guides": "Guías",
  "nav.faq": "FAQ",
  "nav.home": "Inicio",
  "nav.visitMain": "Visitar sitio principal",
  "nav.shoppingGuide": "Guía de compras",

  "hero.eyebrow": "El centro de recursos de Basetao Spreadsheet",
  "hero.title": "Basetao Spreadsheet: productos, vendedores y guías de compra",
  "hero.subtitle": "Explora categorías de productos seleccionadas, consejos de vendedores y guías de compra prácticas — todo organizado en un solo lugar claro y fácil de recorrer.",
  "hero.cta1": "Basetao Spreadsheet",
  "hero.cta2": "Comprar ahora",
  "hero.note": "Todos los enlaces de productos se abren en el sitio principal",

  "dropdown.label": "Explorar categorías",
  "dropdown.placeholder": "Selecciona una categoría de productos",

  "categories.title": "Explora las categorías de productos",
  "categories.subtitle": "Salta directamente a los productos que te interesan. Cada categoría abre una lista filtrada en el sitio principal.",
  "categories.shoes": "Zapatos",
  "categories.hoodies": "Sudaderas / Suéteres",
  "categories.tshirts": "Camisetas",
  "categories.jackets": "Chaquetas",
  "categories.pants": "Pantalones / Shorts",
  "categories.headwear": "Gorras y sombreros",
  "categories.sets": "Conjuntos",
  "categories.underwear": "Ropa interior / Calzoncillos",
  "categories.jersey": "Camisetas deportivas",
  "categories.accessories": "Accesorios",
  "categories.bags": "Bolsos",
  "categories.belts": "Cinturones",
  "categories.perfumes": "Perfumes",
  "categories.other": "Otros artículos",
  "categories.viewAll": "Ver todo en el sitio principal",

  "about.title": "¿Qué es el Basetao Spreadsheet?",
  "about.p1": "El Basetao Spreadsheet reúne enlaces de productos, notas de vendedores y consejos de compra en un directorio fácil de recorrer. En lugar de buscar un artículo a la vez, obtienes un mapa claro de cada categoría — desde zapatos y sudaderas hasta bolsos y perfumes.",
  "about.p2": "Cada categoría abre una vista filtrada en el sitio principal, para que pases de una idea general a un producto concreto con un solo clic. El resultado es una forma más rápida y tranquila de encontrar lo que buscas.",
  "about.p3": "Además del directorio, publicamos guías de compra prácticas sobre vendedores, envíos y control de calidad — todo pensado para que compres con más confianza.",

  "guides.title": "Últimas guías de Basetao",
  "guides.subtitle": "Guías prácticas y originales para explorar y comprar con confianza.",
  "guides.cardTitle": "Basetao Spreadsheet: guía completa (2026)",
  "guides.cardDesc": "Aprende cómo funciona la hoja de cálculo, explora las categorías, encuentra vendedores fiables y entiende el envío y el control de calidad.",
  "guides.readArticle": "Leer la guía completa",
  "guides.updated": "Actualizado ago. 2026",
  "guides.badge": "Guía de compra",

  "faq.title": "Preguntas frecuentes",
  "faq.subtitle": "Respuestas rápidas sobre el Basetao Spreadsheet y cómo usarlo.",
  "faq.q1": "¿Qué es el Basetao Spreadsheet?",
  "faq.a1": "Es un directorio seleccionado de categorías de productos, enlaces y notas de compra que apuntan al sitio principal.",
  "faq.q2": "¿Cómo exploro los productos?",
  "faq.a2": "Usa el menú desplegable de categorías o las tarjetas de abajo. Cada opción abre una lista de productos filtrada en el sitio principal.",
  "faq.q3": "¿Es gratis?",
  "faq.a3": "Sí — explorar el directorio y leer las guías es gratis. Las compras se realizan en el sitio principal.",
  "faq.q4": "¿Cómo compro algo?",
  "faq.a4": "Elige una categoría, encuentra tu producto en el sitio principal y completa el pago allí.",

  "cta.title": "¿Listo para explorar el Basetao Spreadsheet?",
  "cta.subtitle": "Recorre todas las categorías en un solo lugar y salta directamente a los productos que quieres.",
  "cta.primary": "Explorar Basetao Spreadsheet",
  "cta.secondary": "Visitar sitio principal",

  "footer.disclaimer": "Este sitio web es un recurso informativo independiente. La información de productos, vendedores, precios y disponibilidad puede cambiar. Verifica siempre los detalles importantes en el sitio principal antes de comprar.",
  "footer.rights": "© 2026 Basetao Spreadsheet. Todos los derechos reservados.",
  "footer.resources": "Recursos",
  "footer.explore": "Explorar",
  "footer.home": "Inicio",
  "footer.guide": "Guía de Basetao Spreadsheet",
  "footer.categories": "Categorías de productos",
  "footer.visitMain": "Visitar sitio principal",

  "article.notFound": "Artículo no encontrado",
  "article.notFoundDesc": "El artículo que buscas no existe o se ha movido.",
};